import React from "react";
import Vouchers from "../modules/Vouchers/Vouchers";

const VouchersPage = () => (
    <Vouchers/>
)

export default VouchersPage